import { useEffect } from 'preact/hooks';

import { initDatalayerElement } from '../../../components/tracking/datalayer';

import { initInfiniteScroll } from './helpers/infinite-scroll';
import latestNewsPropTypes from './prop-types';
import { renderLatestNews } from './renderers/render-latest-news';
import { renderLatestNewsSkeleton } from './renderers/render-latest-news-skeleton';

const RAIL_POSITION = 'rail';

const LatestNews = ({ widget, htmlProps, state, actions, $root }) => {
  const isRail = htmlProps.position === RAIL_POSITION;

  useEffect(() => {
    const fetchData = async () => {
      actions.setQueryStart();

      try {
        const response = await fetch(htmlProps.current);
        const data = await response.json();
        actions.setQuerySuccess(data);
      } catch (error) {
        actions.setQueryFailure();
        console.warn(`${widget.name} error`, error);
      }
    };
    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const isAfterFirstFetch = state.contents.length > 0 && state.contents.length <= htmlProps.cards;
    if (htmlProps.infinite && isAfterFirstFetch) {
      initInfiniteScroll();
    }

    if (!htmlProps.infinite && !isRail && isAfterFirstFetch) {
      initDatalayerElement($root);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.contents]);

  if (state.error && !state.contents.length) {
    return null;
  }

  if (state.isLoading) {
    return renderLatestNewsSkeleton({
      widget,
      htmlProps,
      isRail,
    });
  }

  return renderLatestNews({
    state,
    widget,
    htmlProps,
    isRail,
  });
};

LatestNews.propTypes = latestNewsPropTypes;

export default LatestNews;
